import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

import { isStorybook, memoryStorage } from "./persistUtils.ts";

// 글자 크기 배율(%). 100% = 브라우저 기본 16px 이며, 그보다 작아지지 않는다.
export const FONT_SCALE_MIN = 100;
export const FONT_SCALE_MAX = 150;
export const FONT_SCALE_STEP = 10;

interface FontScaleState {
  scale: number;
  increase: () => void;
  decrease: () => void;
}

const clamp = (scale: number) =>
  Math.min(FONT_SCALE_MAX, Math.max(FONT_SCALE_MIN, scale));

export const useFontScaleStore = create<FontScaleState>()(
  persist(
    (set) => ({
      scale: FONT_SCALE_MIN,
      increase: () =>
        set((state) => ({ scale: clamp(state.scale + FONT_SCALE_STEP) })),
      decrease: () =>
        set((state) => ({ scale: clamp(state.scale - FONT_SCALE_STEP) })),
    }),
    {
      name: "font-scale-store",
      // Storybook 에서 dev 앱의 영속 키를 덮어쓰지 않도록 in-memory 로 대체한다.
      storage: createJSONStorage(() =>
        isStorybook ? memoryStorage() : localStorage,
      ),
      partialize: (state) => ({ scale: state.scale }),
    },
  ),
);

// rem 기반 크기(text-*, spacing 등)는 루트 font-size 를 따라 한꺼번에 커진다.
const applyFontScale = (scale: number) => {
  document.documentElement.style.fontSize = `${clamp(scale)}%`;
};

// 앱 시작 시 한 번 호출: 저장된 배율을 적용하고 이후 변경을 반영한다.
export function initFontScale() {
  applyFontScale(useFontScaleStore.getState().scale);
  useFontScaleStore.subscribe((state) => applyFontScale(state.scale));
}
